import { getFirestore, collection, getDocs } from "firebase/firestore";
import { app } from "../../firebase";

// Helper to get Firestore collection name based on org/category
export const getCollectionName = (organization: string, category: string) => {
  if (organization === "bytesplash") {
    switch (category) {
      case "offer-letters": return "bytesplash_offerletters";
      case "course-certificates": return "bytesplash_courseCertificates";
      case "id-cards": return "bytesplash_IDCards";
      case "logo": return "bytesplash_Logos";
      case "id-card-threads": return "bytesplash_IDCardThreads";
      case "materials": return "bytesplash_materials";
      case "recorded-videos": return "bytesplash_recordedVideos";
      case "job-bonds": return "bytesplash_jobBonds";
      default: return `bytesplash_${category}`;
    }
  } else if (organization === "margey-labs") {
    switch (category) {
      case "offer-letters": return "margeylabs_offerletters";
      case "internship-certificates": return "margeylabs_InternshipCertificates";
      case "id-cards": return "margeylabs_IDCards";
      case "logo": return "margeylabs_Logos";
      case "id-card-threads": return "margeylabs_IDCardThreads";
      case "materials": return "margeylabs_materials";
      case "recorded-videos": return "margeylabs_recordedVideos";
      case "hr-resources": return "margeylabs_hrResources";
      default: return `margeylabs_${category}`;
    }
  }
  return `${organization}_${category}`;
};

// Get file count for a collection
export const getFileCount = async (organization: string, category: string) => {
  const db = getFirestore(app);
  const collectionName = getCollectionName(organization, category);
  const colRef = collection(db, collectionName);
  const snapshot = await getDocs(colRef);
  return snapshot.size;
};
